import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { KpiStrip } from './KpiStrip';
import { AttentionChart } from './AttentionChart';
import { InsightNotes } from './InsightNotes';
const EASE = [0.23, 1, 0.32, 1] as const;
type InsightsViewProps = {
  onClose: () => void;
};
export function InsightsView({
  onClose
}: InsightsViewProps) {
  return <motion.section aria-labelledby="insights-title" className="absolute inset-0 z-20 overflow-y-auto bg-stage" initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: 8
  }} transition={{
    duration: 0.24,
    ease: EASE
  }} data-id="element-83" data-mp="1q1pv1a8u2q6b">
      <div className="sticky top-0 z-10 border-b border-amber/20 bg-amber-soft" data-id="element-84" data-mp="1ut812cpprgy5">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-2.5 sm:px-5 md:px-8" data-id="element-85" data-mp="1uvap4r7b3008">
          <button type="button" onClick={onClose} className="group inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-ink/15 bg-white px-3.5 py-1.5 text-[13px] font-medium text-ink transition-[border-color] duration-150 hover:border-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-navy" data-id="element-86" data-mp="24rdyah0krywo">
            <ArrowLeftIcon size={14} strokeWidth={2} className="transition-transform duration-150 ease-out group-hover:-translate-x-0.5" data-id="element-87" data-mp="2lw7g80sat832" />
            Back to the presentation
          </button>
          <p className="text-right font-mono text-[10.5px] font-medium tracking-[0.16em] text-amber sm:text-[11.5px]" data-id="element-88" data-mp="2qthc9za70hzv">
            ILLUSTRATIVE DATA — NOT ACTUAL KYOWA KIRIN CAMPAIGN RESULTS
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-4 pb-10 pt-8 sm:px-5 md:px-8" data-id="element-89" data-mp="34n8c2fy4gnie">
        <div className="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between lg:gap-16" data-id="element-90" data-mp="39ls1wrfu6jg1">
          <h2 id="insights-title" className="text-[32px] font-semibold leading-[1.06] tracking-[-0.035em] text-ink lg:text-[40px]" data-id="element-91" data-mp="3ekw9xer0yb4s">
            Every interaction creates a signal.
          </h2>
          <p className="max-w-[480px] text-[14px] leading-relaxed text-graphite" data-id="element-92" data-mp="2jxnzhpmme4wr">
            Snaks don’t just communicate evidence. They reveal which clinical topics capture HCP attention and where future
            engagement could add value.
          </p>
        </div>

        <KpiStrip data-id="element-93" data-mp="2tuix86b2k19z" />

        <div className="mt-4 grid gap-4 lg:grid-cols-12" data-id="element-94" data-mp="2ttzggsx5nixj">
          <AttentionChart data-id="element-95" data-mp="37lxiykwd2gkq" />
          <InsightNotes data-id="element-96" data-mp="37pbi7k9qa9ny" />
        </div>

        <p className="mt-6 max-w-3xl text-[11.5px] leading-relaxed text-graphite/85" data-id="element-97" data-mp="32onkyguwowla">
          Hypothetical, internally consistent figures for a single illustrative campaign wave, shown to demonstrate the
          reporting format. Engagement data describe interest and interaction only; they do not show changes in clinical
          practice or prescribing behaviour.
        </p>
      </div>
    </motion.section>;
}